export const TASK_TYPES = {
  extractDeliveryNote: 'EXTRACT_DELIVERY_NOTE',
} as const;
